// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___1LgyK","top":"top___1qv8h","message":"message___L0klf","confirmMessage":"confirmMessage___1PtrE","links":"links___3o8dW","submit":"submit___j-Ama"};